<template>
  <div class="select-wrapper">
    <select-input select-class="country-select" v-model="countryGeoId" :options="countryOptions"
      :placeholder="placeholder" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import GeoClient from '../http/GeoClient';
import SelectInput from './inputs/SelectInput.vue';

export default {
  name: 'country-select',
  created() {
    this.geoClient = new GeoClient(this.getBearerToken());
    this.geoClient.fetchCountries();
  },
  watch: {
    countryGeoId() {
      this.$root.$emit('country-change', this.countryGeoId);
      this.setLoading(true);
    },
  },
  data() {
    return {
      geoClient: null,
      countryGeoId: null,
    };
  },
  computed: {
    ...mapState({
      countryOptions: (state) => state.geo.countryOptions,
    }),
    placeholder() {
      return 'Select country / territory';
    },
  },
  methods: {
    ...mapActions({
      setCountry: 'setCountry',
      setLoading: 'setLoading',
    }),
    ...mapGetters({
      getBearerToken: 'getBearerToken',
    }),
  },
  components: {
    SelectInput,
  },
};
</script>
